import React from 'react'
import RowButton from 'components/atoms/row-button'
import StringUtil from 'utils/string-util'

const customerOrderRefundItemTableColumns = ({ handleClickEdit, handleClickDelete }) => {


  // Custom Cell
  // Used to modify the cell in specific columns
  const ImageCell = (row) => <img style={{ width: '8rem' }} src={ row.cell.value } alt={ row.row.original.name }/>
  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => (
    <>
      <div className='my-2'>
        <RowButton
          // eslint-disable-next-line react/prop-types
          data={ row.original }
          className="w-100"
          color='primary'
          onClick={ handleClickEdit }
          text="edit"
        />
      </div>
      <div className='my-2'>
        <RowButton
          // eslint-disable-next-line react/prop-types
          data={ row.original }
          className="w-100"
          color='success'
          onClick={ handleClickDelete }
          text="delete"
        />
      </div>
    </>
  )

  const HumanizeStringCell = (row) =>  StringUtil.humanize(row.cell.value)

  return (
    [
      {
        Header         : 'Image',
        accessor       : 'image',
        disableFilters : true,
        Cell           : ImageCell
      },
      {
        Header         : 'SKU',
        accessor       : 'sku',
        disableFilters : true
      },
      {
        Header         : 'Name',
        accessor       : 'name',
        disableFilters : true
      },
      {
        Header         : 'Reason',
        accessor       : 'reason',
        disableFilters : true,
        Cell           : HumanizeStringCell
      },
      {
        Header         : <>Reason<br/>Details</>,
        accessor       : 'reason_details',
        disableFilters : true
      },
      {
        Header         : <>Refund<br/>Method</>,
        accessor       : 'refund_method',
        disableFilters : true,
        Cell           : HumanizeStringCell
      },
      {
        Header         : <>Resolution<br/>Action</>,
        accessor       : 'resolution_action',
        disableFilters : true,
        Cell           : HumanizeStringCell
      },
      {
        Header         : <>Ops<br/>Notes</>,
        accessor       : 'ops_notes',
        disableFilters : true
      },
      {
        Header         : 'Action',
        accessor       : 'action',
        disableFilters : true,
        Cell           : ActionCell
      }
    ]
  )
}

export default customerOrderRefundItemTableColumns